import { AdminApi } from 'stylemix-vue-admin'

export default class PriceZonesApi extends AdminApi {
  constructor(vehicleId, parameters) {
    const path = vehicleId
      ? `vehicles/${vehicleId}/zone-to-zone-prices`
      : 'zone-to-zone-prices'
    super(path, parameters)
  }
}
